import { renderToString } from 'react-dom/server'

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ModalConfirm from '../../ui/ModalConfirm';
import { EndPointMethod, RequestBackend } from '../../backend/RequestBackend';
import { showError } from '../../../ui/ToastErrore';

export class AffiliateBtnPay extends Component {

    constructor(props) {
        super(props);

        this.state = {
            'admin_address': this.props.admin,
            'address': this.props.address,
            'disabled': this.props.disabled ? true : false,
            'loading': false,
            'arrayProfits': null,
            'totalAmount': 0
        }
        this.prepareModalPay = this.prepareModalPay.bind(this);
    }

    async prepareModalPay() {
        if (!this.state.disabled && this.state.address && !this.state.loading) {
            this.modalPay();
        }
    }

    async modalPay() {

        this.setState({ loading: true });

        // Carico l'array di NFT da pagare assieme
        const request = new RequestBackend(this.state.admin_address, EndPointMethod.AFFILIATE_ADMIN_PREPARE_PAY, {
            address: this.state.address
        });
        const response = await request.run();

        if (request.getStatusCode() == 200) {
            if (response.error) {
                showError({ 'titolo': 'Error', 'testo': response.error });
                this.setState({ loading: false });
                return false;
            }

            const response_data = response.data;
            this.setState({
                'totalAmount': response_data.totalAmount,
                'arrayProfits': response_data.arrayProfits
            });
        }

        // Modal per pagare
        const modalDescription = renderToString(
            <div>
                <div className='affiliate-paid-form'>
                    { /* <div className='affiliate-paid-icon'>
                        <FontAwesomeIcon icon={faCopy} />
                    </div> */ }
                    <div className='affiliate-paid-address'>
                        <p className='label-addressref'>Address sponsor:</p>
                        <p className='addressref'>
                            <input type={'text'} readOnly value={this.state.address} />
                        </p>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>
                <p style={{ margin: 0, marginBottom: 8 }}>You're paying {this.state.arrayProfits && Array.from(this.state.arrayProfits) ? Array.from(this.state.arrayProfits).length : 0} profits together</p>
                <p style={{ margin: 0 }}>Total to Pay: <span className='greenTdValue'>{this.state.totalAmount} ETH</span></p>
            </div>
        );

        const modalConfirm = new ModalConfirm("Commissions Payment", modalDescription, "Make as paid");
        const responseModal = await modalConfirm.waitModal();
        if (!responseModal) {
            this.setState({ loading: false });
            return false;
        }

        // Imposto i profitti come pagati
        await this.pay();

        this.setState({ loading: false });
    }

    async pay() {

        const request = new RequestBackend(this.state.admin_address, EndPointMethod.AFFILIATE_ADMIN_PAY, {
            arrayProfits: JSON.stringify(this.state.arrayProfits)
        });
        const response = await request.run();

        if (request.getStatusCode() == 200) {
            if (response.error) {
                showError({ 'titolo': 'Error', 'testo': response.error });
            } else {
                if (response.status && response.status == "ok") {
                    window.location.reload();
                } else {
                    showError({ 'titolo': 'Error', 'testo': 'A problem occurred' });
                }
            }
        }
    }

    render() {
        return (<span onClick={() => this.prepareModalPay()} className={'gestione-btn pay-btn ' + (this.state.disabled || this.state.loading ? 'disabled' : '')}>
            Pay {this.state.loading ? <>&nbsp;&nbsp;<FontAwesomeIcon icon={faSpinner} spin /></> : ''}
        </span>);
    }
}

export default AffiliateBtnPay;